import styled from 'styled-components';
export var Results = styled.ul.withConfig({
  displayName: "Results",
  componentId: "sc-15fdea6-0"
})(["position:absolute;z-index:10;top:", ";", ";", ";overflow:hidden;border-radius:", ";box-shadow:", ";background-color:#fff;white-space:nowrap;transform:translateY(10px);user-select:none;"], function (_ref) {
  var top = _ref.top;
  return top !== null ? "".concat(top, "px") : '100%';
}, function (_ref2) {
  var left = _ref2.left;
  return left !== null ? "left: ".concat(left, "px;") : 'right: 0;';
}, function (_ref3) {
  var width = _ref3.width;
  return width ? "max-width: ".concat(width, "px;") : null;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.boxShadow;
});